// frontend/src/components/layout/StoreChip.jsx
//
// A store's identity chip: its initials on its colour, the store-side twin of
// UserChip.

import { avatarColor, initials, storeDisplayName } from '../../utils/avatar';
import '../../styles/avatar-chip.css';

/** @param {{ store: object, size?: 'sm' | 'lg' }} props */
export default function StoreChip({ store, size }) {
  return (
    <span className={`avatar-chip${size ? ` avatar-chip--${size}` : ''}`} style={{ background: avatarColor(store.id) }}>
      {initials(storeDisplayName(store))}
    </span>
  );
}
